<vpfa-header-title
  #headerTitle
  [extraLeftTemplate]="extraLeftTemplate"
  [extraRightTemplate]="extraRightTemplate"
  [title]="tableName"
></vpfa-header-title>
